import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Modal, Typography, IconButton, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import {
  allotVehicle,
  allotToSupplier,
  clearGetAvailableSuplliers,
  clearGetAvailableVehicle,
  getAvailableSuplliers,
  getAvailableVehicle,
  reAssignDriver,
} from 'redux/actions/OperationsAction';
import { getReservationDetails } from 'redux/actions/reservationAction';
import { debounce } from 'lodash';
import { getDateFormat, getReservationDetailsObject, getTimeFormat } from 'utils/utils';
import Loader from 'components/loader/Loader';
import SearchBar from 'components/commonSearch/SearchBar';
import AllotingVehicleTable from './AllotingVehicleTable';
import ReasonModal from 'components/reasonModal/ReasonModal';

import NotifyRecipientsModal from 'components/notifyRecipientsModal/NotifyRecipientsModal';

const AllotVehicleModal = ({ open, toggle, tripDetails, page, payload }) => {
  const [notifyModalOpen, setNotifyModalOpen] = useState(false);
  const [notifyType, setNotifyType] = useState('vehicleAssignment');

  const dispatch = useDispatch();
  const [tabSelect, setTabSelect] = useState('myVehicles');
  const [search, setSearch] = useState('');
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedVehicleForAssign, setSelectedVehicleForAssign] = useState(null);
  const [selectedSupplierForAssign, setSelectedSupplierForAssign] = useState(null);

  useEffect(() => {
    if (tripDetails?.id) {
      if (
        page === 'listPage' ||
        page === 'allot' ||
        page === 'Reservation' ||
        page === 'dispatch'
      ) {
        dispatch(getReservationDetails(tripDetails?.id));
      }

      if (open) {
        dispatch(getAvailableVehicle(tripDetails?.id));
      }
    }
  }, [open]);

  useEffect(() => {
    return () => {
      dispatch(clearGetAvailableSuplliers());
      dispatch(clearGetAvailableVehicle());
    };
  }, []);

  const restripDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data,
  );

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };

  //---Time Format---
  const handleTimeFormat = (date) => {
    return getTimeFormat(date);
  };

  const reservationDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data,
  );

  const details = getReservationDetailsObject(reservationDetails);

  const myvehicleList = useSelector((state) => state?.getAvailableVehicle?.availableVehicle?.data);
  const myvehicleListLoader = useSelector((state) => state?.getAvailableVehicle?.loading);
  const mySupplierList = useSelector(
    (state) => state?.availableSuppliers?.availableSuppliers?.data,
  );
  const mySupplierListLoader = useSelector((state) => state?.availableSuppliers?.loading);

  // Client-side filter for suppliers (backend may not support search param)
  const filteredSupplierList = mySupplierList?.filter((s) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      s?.subVendorName?.toLowerCase().includes(term) || s?.cityName?.toLowerCase().includes(term)
    );
  });

  const AllRidesModalTableData = {
    ID: reservationDetails?.tripId || 'NA',
    Status: reservationDetails?.status || 'NA',
    'Start Date': reservationDetails?.scheduledTime
      ? handleDateFormating(reservationDetails?.scheduledTime)
      : 'NA',
    'End Date': details?.tripEndTime ? handleDateFormating(details?.tripEndTime) : 'NA',
    'Reporting time': reservationDetails?.scheduledTime
      ? handleTimeFormat(reservationDetails?.scheduledTime)
      : 'NA',
    City: restripDetails?.ServiceCity?.name || 'NA',
    'Duty Type': reservationDetails?.dutyTypeName || 'NA',
    'Vehicle Group': reservationDetails?.MasterCarType?.carType || 'NA',
  };

  const handleChange = (event, newValue) => {
    setTabSelect(newValue);
    setSearch('');
    if (newValue === 'myVehicles') {
      dispatch(getAvailableVehicle(tripDetails?.id));
    } else {
      dispatch(getAvailableSuplliers(tripDetails?.id));
    }
  };

  // UPDATE THIS FUNCTION
  const handleClose = () => {
    toggle();
    setTabSelect('myVehicles');
    setSearch('');
    setShowReasonModal(false);
    setSelectedVehicleForAssign(null);
    setSelectedSupplierForAssign(null);
  };

  const filterData = (data) => {
    if (data[0] !== 'Duty Type' && data[0] !== 'Vehicle Group') {
      return true;
    } else {
      return false;
    }
  };

  const handleAllot = (vehicleDetails) => {
    const isReassign =
      ['alloted', 'dispatched', 'ongoing'].includes(reservationDetails?.status?.toLowerCase()) ||
      reservationDetails?.additionalInfo?.subVendorAssignmentStatus === 'rejected';

    // ── Sub-vendor path ──
    if (tabSelect === 'mySuppliers') {
      const data = {
        tripId: tripDetails?.id,
        subVendorCompanyId: vehicleDetails?.subVendorId,
      };

      if (isReassign) {
        setSelectedSupplierForAssign(vehicleDetails);
        setShowReasonModal(true);
      } else {
        dispatch(allotToSupplier(data, page, payload));
        handleClose();
        setSearch('');
      }
      return;
    }

    // ── Existing vehicle path (unchanged) ──
    setSelectedVehicleForAssign(vehicleDetails);

    const isUpgrade = vehicleDetails?.Vehicle?.carTypeId !== reservationDetails?.carTypeId;

    if (isReassign || isUpgrade) {
      setShowReasonModal(true);
    } else {
      const data = {
        tripId: tripDetails?.id,
        driverId: vehicleDetails?.Vehicle?.driverId,
        vehicleId: vehicleDetails?.Vehicle?.id,
      };
      // dispatch(allotVehicle(data, page, payload));
      dispatch(
        allotVehicle(data, page, payload, () => {
          handleClose();
          setNotifyType('vehicleAssignment');
          setNotifyModalOpen(true);
        }),
      );

      // handleClose();
      setSearch('');
    }
  };

  // const handleReasonSubmit = (reasonData) => {
  //   const isReassign = ["alloted", "dispatched", "ongoing"].includes(
  //     reservationDetails?.status?.toLowerCase(),
  //   );
  //   // Call API with reason and comments
  //   const data = {
  //     tripId: tripDetails?.id,
  //     driverId: selectedVehicleForAssign?.Vehicle?.driverId,
  //     vehicleId: selectedVehicleForAssign?.Vehicle?.id,
  //     reason: reasonData.reason,
  //     comments: reasonData.comments,
  //   };
  //   // dispatch(allotVehicle(data, page, payload));
  //   // handleClose();

  //   dispatch(
  //     allotVehicle(data, page, payload, () => {
  //       handleClose();
  //       setNotifyType("vehicleReassignment");
  //       setNotifyModalOpen(true);
  //     }),
  //   );
  //   if (isReassign) {
  //     dispatch(reAssignDriver(data, page, payload)); // NEW API HIT
  //   } else {
  //     dispatch(allotVehicle(data, page, payload)); // OLD API HIT
  //   }
  //   handleClose();
  //   setSearch("");
  // };

  const handleReasonSubmit = (reasonData) => {
    const isReassign =
      ['alloted', 'dispatched', 'ongoing'].includes(reservationDetails?.status?.toLowerCase()) ||
      reservationDetails?.additionalInfo?.subVendorAssignmentStatus === 'rejected';

    if (tabSelect === 'mySuppliers') {
      const data = {
        tripId: tripDetails?.id,
        subVendorCompanyId: selectedSupplierForAssign?.subVendorId,
        reason: reasonData.reason,
        comments: reasonData.comments,
      };
      dispatch(allotToSupplier(data, page, payload));
      handleClose();
      setSearch('');
      return;
    }

    const data = {
      tripId: tripDetails?.id,
      driverId: selectedVehicleForAssign?.Vehicle?.driverId,
      vehicleId: selectedVehicleForAssign?.Vehicle?.id,
      reason: reasonData.reason,
      comments: reasonData.comments,
    };

    if (isReassign) {
      // Reassignment case → vehicleReassignment
      dispatch(
        reAssignDriver(data, page, payload, () => {
          handleClose();
          setNotifyType('vehicleReassignment'); // ← Different type
          setNotifyModalOpen(true);
        }),
      );
    } else {
      // Upgrade case → vehicleAssignment
      dispatch(
        allotVehicle(data, page, payload, () => {
          handleClose();
          setNotifyType('vehicleAssignment');
          setNotifyModalOpen(true);
        }),
      );
    }
  };

  const handleBackFromReasonModal = () => {
    setShowReasonModal(false);
    setSelectedVehicleForAssign(null);
  };

  const isUpgradeScenario = () => {
    if (!selectedVehicleForAssign || !reservationDetails) return false;
    return selectedVehicleForAssign?.Vehicle?.carTypeId !== reservationDetails?.carTypeId;
  };

  const getAssignType = () => {
    return ['alloted', 'dispatched', 'ongoing'].includes(
      reservationDetails?.status?.toLowerCase(),
    ) || reservationDetails?.additionalInfo?.subVendorAssignmentStatus === 'rejected'
      ? 'reassign'
      : 'assign';
  };
  const onSearch = useCallback(
    debounce((e) => {
      setSearch(e);
      const searchFilterData = {
        id: tripDetails?.id,
        search: e,
      };
      if (tabSelect === 'myVehicles') {
        dispatch(getAvailableVehicle(searchFilterData));
      } else {
        dispatch(getAvailableSuplliers(searchFilterData));
      }
    }, 500),
    [tabSelect, tripDetails?.id],
  );

  return (
    <>
      <Modal
        open={open && !showReasonModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="customModal"
        onClose={handleClose}
      >
        <Box
          className="modalContent allotModalContent textLeft"
          sx={{ height: { xs: 'fit-content', sm: 'auto' } }}
        >
          <Box className="allotModalContentWrapper">
            <Box className="closeIcon justifyBetween">
              <Typography variant="head3" component={'h1'} className="colorPrimary fw600 mb10">
                Duty Allotment
              </Typography>
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>

            {reservationDetails?.id ? (
              <Grid container className="mt30 mb20 borderSolidGrey">
                {Object.entries(AllRidesModalTableData)
                  .filter((element) => filterData(element))
                  .map((key) => (
                    <Grid key={key} item xs={12} md={6} container>
                      <Grid xs={4} md={6} item className="p10 alignStart borderSolidGrey pl25">
                        <Typography variant={'body2'} className="colorGrey">
                          {key[0]}
                        </Typography>
                      </Grid>
                      <Grid xs={8} md={6} item className="p10 alignStart borderSolidGrey pl25">
                        <Typography variant={'body2'}>{key[1]}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                {Object.entries(AllRidesModalTableData)
                  .filter((element) => {
                    if (element[0] === 'Duty Type' || element[0] === 'Vehicle Group') {
                      return true;
                    }
                    return false;
                  })
                  .map((key) => (
                    <Grid key={key} item xs={12} container>
                      <Grid xs={4} md={3} item className="alignStart borderSolidGrey pl25">
                        <Typography variant={'body2'} className="colorGrey">
                          {key[0]}
                        </Typography>
                      </Grid>
                      <Grid xs={8} md={9} item className="alignStart borderSolidGrey pl25 p10">
                        <Typography variant={'body2'}>{key[1]}</Typography>
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
            ) : (
              <Loader height="40vh" />
            )}

            <TabContext value={tabSelect.toString()}>
              <Grid container className="tabBoxStyle justifyBetween flexColumn pl40">
                <Grid item justifyContent={'center'} container>
                  <TabList
                    className="minHeight32"
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="My Vehicles" value="myVehicles" className="tabStyle colorGrey" />
                    <Tab label="My Suppliers" value="mySuppliers" className="tabStyle colorGrey" />
                  </TabList>
                </Grid>
              </Grid>
              <TabPanel value="myVehicles">
                <>
                  <SearchBar onSearchQuery={onSearch} search={search} />
                  {myvehicleListLoader ? (
                    <Loader height="15vh" />
                  ) : (
                    <div className="mt20">
                      <AllotingVehicleTable
                        myvehicleList={myvehicleList}
                        handleAllot={handleAllot}
                        tab={tabSelect}
                      />
                    </div>
                  )}
                </>
              </TabPanel>
              <TabPanel value="mySuppliers">
                <>
                  <SearchBar onSearchQuery={onSearch} search={search} />
                  {mySupplierListLoader ? (
                    <Loader height="15vh" />
                  ) : (
                    <div className="mt20">
                      <AllotingVehicleTable
                        myvehicleList={filteredSupplierList}
                        handleAllot={handleAllot}
                        tab={tabSelect}
                      />
                    </div>
                  )}
                </>
              </TabPanel>
            </TabContext>
          </Box>
        </Box>
      </Modal>

      <ReasonModal
        open={showReasonModal}
        onClose={() => {
          setShowReasonModal(false);
          setSelectedVehicleForAssign(null);
          setSelectedSupplierForAssign(null);
        }}
        onBack={handleBackFromReasonModal}
        onSubmit={handleReasonSubmit}
        assignType={getAssignType()}
        isUpgrade={isUpgradeScenario()}
        selectedVehicle={selectedVehicleForAssign}
        tripDetails={reservationDetails}
      />

      <NotifyRecipientsModal
        open={notifyModalOpen}
        toggle={() => setNotifyModalOpen(false)}
        tripId={tripDetails?.id}
        notificationType={notifyType}
      />
    </>
  );
};

export default AllotVehicleModal;
